module.exports = __webpack_public_path__ + "static/media/lekaPopEmail.8bd5ca3a.png";